import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import Select from 'react-select';
import Utils from '../Utils';
var lodash = require('lodash')

class DatabaseSelect extends Component {

  constructor(props) {
    super(props);

    this.state = {
      servers: [],
      databases_servers:[],
      fetching_databases: true,
      submitting: false,
      database_server:'',
      last_connections: []
    }
  }

    handleSelectKeyDown = (event) => {
      if (event.key === 'Enter') {
        if (this.state.database_server && !this.state.submitting) {
          event.preventDefault();
          this.handleSubmit(event);
        }
      }
    }

  componentDidMount() {
    if(Utils.isAccesClient()){
      window.location.href = '/';
      return;
    }

    localStorage.backoffice_api = process.env.REACT_APP_BACKOFFICE_API
    delete localStorage.bdgp_selected;
    window.dispatchEvent(new Event('bdgp_selected'))

    this.loadLastConnections()
    this.fetchServers();
  }

  fetchServers() {
    fetch(process.env.REACT_APP_BACKOFFICE_API + '/api/servers', {
      method: 'GET',
      headers: {
        authorization: localStorage.JWT,
      }
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      this.setState({
        servers: json,
      }, () => {
        this.fetchDatabase_servers();
      });
    })
    .catch((error) => {
      console.log(error)
    });
  }

  fetchDatabase_servers() {
    this.setState({
      fetching_databases: true,
    })
    var res = [];
    let nbServersProcessed = 0;
    let nbServers = this.state.servers.length;
    
    this.state.servers.forEach(s => {
      
      localStorage.backoffice_api = process.env.REACT_APP_BACKOFFICE_API
      if (s.isHonda) {
        localStorage.backoffice_api = process.env.REACT_APP_BACKOFFICE_API_HONDA
      }
      fetch(localStorage.backoffice_api + '/api/databases', {
        method: 'GET',
        headers: {
          server: s.ip,
          authorization: localStorage.JWT,
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((json) => {
        json.forEach(db => {
          res.push({
            database: db,
            server: s
          });
        });
        nbServersProcessed++;
        this.setState({
          databases_servers: lodash.sortBy(res, (d) => {
            return d.database.name
          }),
          fetching_databases: nbServersProcessed < nbServers,
        }); 
      })
      .catch((error) => {
        nbServersProcessed++;
        this.setState({
          fetching_databases: nbServersProcessed < nbServers,
        });
        console.log(error)
      });
    })
  }

  onChangeDatabaseServer(event) {
    this.setState({
      database_server: event ? event.value : null,
    });
  }

  handleSubmit(event) {
    event?.preventDefault()
    this.setState({
      submitting: true,
    })

    var res = lodash.filter(this.state.databases_servers, (db_serv) => {
      var ip = this.state.database_server.split("/")[1];
      var name = this.state.database_server.split("/")[0];
      if(db_serv.server.ip == ip && db_serv.database.name == name){
        return db_serv;
      }
    })

    localStorage.backoffice_api = process.env.REACT_APP_BACKOFFICE_API
    if (res[0].server.isHonda) {
      localStorage.backoffice_api = process.env.REACT_APP_BACKOFFICE_API_HONDA
    }

    if (!res.length) {
      this.setState({
        submitting: false,
      });
      return;
    }

    fetch(localStorage.backoffice_api + '/api/adminSelectDatabase', {
      method: 'POST',
      headers: {
        server: res[0].server.ip,
        bdgp: res[0].database.name,
        authorization: localStorage.JWT,
      }
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      localStorage.JWT = 'JWT ' + json.token;
      localStorage.bdgp_selected = 1;
      localStorage.activites = json.activites;
      this.saveLastConnections();
      window.dispatchEvent(new Event('bdgp_selected'))
      this.props.history.push('/dashboard')
    })
    .catch((error) => {
      console.log(error)
    }); 

  }

  getServerNameFromIP(ip) {
    const server = this.state.servers.find(s => s.ip === ip);
    return server ? server.name : '';
  }

  formatConnectionName(connectionName) {
    const [dbName, ip] = connectionName.split('/');
    const serverName = this.getServerNameFromIP(ip);
    return `${dbName} (${serverName} - ${ip})`;
  }

  loadLastConnections() {
    const lastConnectionsList = JSON.parse(localStorage.getItem('last_connections') || '[]');
    this.setState({ last_connections: lastConnectionsList });
  }

  saveLastConnections() {
    let lastConnectionsList = JSON.parse(localStorage.getItem('last_connections') || '[]');
    lastConnectionsList = lastConnectionsList.filter(item => item !== this.state.database_server);
    lastConnectionsList.unshift(this.state.database_server);
    lastConnectionsList = lastConnectionsList.slice(0, 10);
    localStorage.setItem('last_connections', JSON.stringify(lastConnectionsList));
  }

  removeConnection = (connectionName) => {
    let lastConnectionsList = JSON.parse(localStorage.getItem('last_connections') || '[]');
    lastConnectionsList = lastConnectionsList.filter(item => item !== connectionName);
    localStorage.setItem('last_connections', JSON.stringify(lastConnectionsList));
    this.setState({ last_connections: lastConnectionsList });
  }

  render() {

    return (
      <div className='container' style={{ marginTop: '50px' }}>
        <div className='row justify-content-center'>
          <div className='col-lg-6 col-md-6 text-center'>
            <h3 style={{ marginBottom: '20px' }}>Sélection d'un client</h3>

            <form className="form-inline" onSubmit={this.handleSubmit.bind(this)}>

              <div className="col-sm-12 text-left" style={{ marginTop: '15px' }}>
                <Select
                  multi={false}
                  name="database"
                  value={this.state.database_server}
                  options={this.state.databases_servers.map((item) => {
                    return {value:  item.database.name+'/'+item.server.ip, label: item.database.name + ' ('+ item.server.name + ' - ' + item.server.ip + ')' } ;
                  })}
                  searchable={true}
                  placeholder='Choisissez une base de données'
                  onChange={this.onChangeDatabaseServer.bind(this)}
                  required={true}
                  onInputKeyDown={this.handleSelectKeyDown}
                />
              </div>

              <div className='text-center' style={{ width: '100%', }}>
                <button disabled={this.state.submitting} type="submit" className="btn btn-primary" style={{ marginTop: '15px', width: '80%', visibility: this.state.database_server ? 'visible' : 'hidden'}}>
                  {this.state.submitting ?
                    <span><i className='fa fa-spinner fa-spin fa-fw'></i>&nbsp;</span>
                  : null}
                  Valider
                </button>
              </div>

              {/* Affichage des dernières connexions utilisées */}
              {this.state.last_connections && this.state.last_connections.length > 0 && !this.state.fetching_databases ?
                <div className='tw-mt-12 tw-mb-2 tw-w-full tw-text-left'>
                  <div className='tw-font-bold tw-mb-2'>Dernières connexions utilisées :</div>
                  <div className='tw-flex tw-flex-col tw-gap-3'>
                    {this.state.last_connections.map((connectionName, idx) => (
                      <div key={connectionName+idx} className='tw-flex tw-items-stretch tw-gap-2 tw-w-full'>
                        <a
                          type="button"
                          className="tw-w-full tw-rounded tw-text-gray-900 tw-px-3 tw-py-2 tw-bg-gray-100 hover:tw-no-underline hover:tw-text-black hover:tw-bg-gray-200 focus:tw-ring-1 focus:tw-ring-gray-300"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ database_server: connectionName }, () => {
                              this.handleSubmit();
                            });
                          }}
                        >
                          {this.formatConnectionName(connectionName)}
                        </a>
                        <button
                          type="button"
                          className="tw-text-red-600 tw-bg-transparent tw-border-none tw-px-1 tw-py-1"
                          title="Supprimer cette connexion"
                          onClick={() => this.removeConnection(connectionName)}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              : null}

            </form>

          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DatabaseSelect);
